<template>
  <header class="print-hidden">
    <div class="mx-15 container__custom">
      <router-link to="/user" class="navbar-brand">
        <Spinner :theme="primary" v-if="loader" />
        <template v-else>
          <img
            v-if="isDefaultLogo.length && !isDefaultLogo[1].value.status"
            :src="isDefaultLogo[0].value.image"
            style="width: 170px; height: 60px; border-radius: 5px;"
            alt=""
          />
          <img
            v-else
            src="@/assets/media/brand.svg"
            style="width: 170px; height: 60px; border-radius: 5px;"
            alt="QSpace Logo"
          />
        </template>
      </router-link>
      <TopbarNav />
    </div>
  </header>
</template>

<script>
import TopbarNav from "@/modules/user/elements/TopbarNav";

const Spinner = () => import("@/components/Spinner");

export default {
  components: {
    TopbarNav,
    Spinner
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "defaultlogo");
    this.loader = false;
    this.isDefaultLogo = this.options;
  },
  data() {
    return {
      isDefaultLogo: [
        {
          value: {
            image: null
          }
        },
        {
          value: {
            status: false
          }
        }
      ],
      loader: true
    };
  }
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

@import "@/assets/scss/custom/_grid.scss";
header {
  height: 6.25rem;
}

.container__custom {
  display: flex;
  height: 100%;
  justify-content: space-between;
}

.navbar-brand {
  align-self: center;
  img {
    object-fit: contain;
  }
}

.icon-brand {
  height: 3rem;
  width: 3rem;
}

.app__header {
  &--shadow {
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05);
  }
}

@media print {
  .print-hidden {
    display: none !important;
  }
}
</style>
